import type { ReactNode } from 'react';

/** Personal data (a name, e-mail address or phone number): blurred while personal data is hidden (lib/privacy). */
export function Pii({ children }: { children: ReactNode }) {
  return <span className="pii">{children}</span>;
}
